import { NgFor, isPlatformBrowser } from "@angular/common";
import {
  Component,
  ContentChildren,
  QueryList,
  AfterViewInit,
  AfterContentInit,
  ElementRef,
  ViewChild,
  PLATFORM_ID,
  Inject,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import KeenSlider, { KeenSliderInstance } from "keen-slider";
import { environment } from "../../../environments/environment";
import { Subscription } from "rxjs";

@Component({
  selector: "glo-carousel",
  templateUrl: "./carousel.component.html",
  styleUrls: ["./carousel.component.scss"],
  imports: [NgFor],
})
export class GloCarouselComponent
  implements AfterContentInit, AfterViewInit, OnDestroy
{
  @ViewChild("sliderRef") sliderRef!: ElementRef<HTMLElement>;
  @ContentChildren("carouselSlide") slidesContent!: QueryList<ElementRef>;

  assetUrl = environment.assetBaseUrl;

  slider!: KeenSliderInstance;
  currentSlide = 0;
  dots: number[] = [];

  private slidesChangeSub?: Subscription;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private cdr: ChangeDetectorRef,
  ) {}

  ngAfterContentInit(): void {
    this.updateDots();

    this.slidesChangeSub = this.slidesContent.changes.subscribe(() => {
      this.updateDots();

      if (this.slider) {
        queueMicrotask(() => {
          this.slider.update();
        });
      }
    });
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.slider = new KeenSlider(this.sliderRef.nativeElement, {
        loop: true,
        slideChanged: (s) => {
          this.currentSlide = s.track.details.rel;
          this.cdr.detectChanges();
        },
      });
    }
  }

  ngOnDestroy(): void {
    this.slidesChangeSub?.unsubscribe();
    this.slider?.destroy();
  }

  private updateDots(): void {
    this.dots = Array.from({ length: this.slidesContent.length }, (_, i) => i);

    this.cdr.detectChanges();
  }

  moveToSlide(idx: number): void {
    this.slider?.moveToIdx(idx);
  }

  prev(): void {
    this.slider?.prev();
  }

  next(): void {
    this.slider?.next();
  }
}
